import { lazy } from 'react';

export const Layout = lazy(() => import('./Layout'));
export const PaymentMethods = lazy(() => import('./paymentGateway/PaymentMethods'));
export const Dashboard = lazy(() => import('./dashboard/Dashboard'));
export const BookTableModal = lazy(() => import('./common/BookTableModal'));
export const EditProfile = lazy(() => import('./common/EditProfile'));
export const ModalBox = lazy(() => import('./common/ModalBox'));